import {
    MenuEntry,
    MenuEntryChild,
} from '../../../build/swagger-code-extranet-api-definition/models'; // eslint-disable-line import/no-cycle
import { ParamUtils } from './ParamUtils';

export class ApplicationBarMenuEntryMapper {
    public static mapMenuEntryUrls(
        menuEntries: MenuEntry[],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params: any,
    ): MenuEntry[] {
        return menuEntries.map((menuEntry) => {
            return {
                ...menuEntry,
                url: ParamUtils.getUrlWithParams(menuEntry.url, params),
                apps: this.mapSubMenuEntries(menuEntry, params),
            };
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static mapSubMenuEntries(menuEntry: MenuEntry, params: any) {
        if (menuEntry.apps == null) {
            return [];
        }
        return menuEntry.apps.map((app: MenuEntryChild) => {
            return {
                ...app,
                url: ParamUtils.getUrlWithParams(app.url, params),
            };
        });
    }
}
